(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Our_best_selling_section"] && !Shopify.designMode) return;
  try {
    

// document.querySelectorAll('.add-to-bag-btn').forEach(button => {
//   button.addEventListener('click', function (e) {
//     e.preventDefault();

//     console.log('🟢 Add to Bag clicked');

//     const productIndex = this.dataset.productIndex;
//     console.log('Product Index:', productIndex);

//     const select = document.querySelector(`#variant-select-${productIndex}`);
//     if (!select) {
//       console.error('❌ Variant select not found');
//       return;
//     }

//     const variantId = select.value;
//     console.log('Selected Variant ID:', variantId);

//     const btn = this;
//     btn.disabled = true;

//     console.log('🟡 Sending request to /cart/add.js');

//     fetch('/cart/add.js', {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//         'Accept': 'application/json'
//       },
//       body: JSON.stringify({
//         id: variantId,
//         quantity: 1
//       })
//     })
//     .then(response => {
//       console.log('🟢 Product added to cart');
//       return response.json();
//     })
//     .then(data => {
//       console.log('Cart add response:', data);

//       console.log('🟡 Fetching updated cart sections...');
//       return fetch('/?sections=mini-cart,cart-icon-bubble,mobile-cart-icon-bubble');
//     })
//     .then(res => res.json())
//     .then(sections => {

//       console.log('🟢 Sections fetched successfully');
//       console.log('Sections:', sections);

//       const miniCart = document.getElementById('mini-cart');
//       console.log('Mini Cart Element:', miniCart);

//       if (!miniCart) {
//         console.error('❌ Mini cart element NOT found');
//         location.reload();
//         return;
//       }

//       console.log('🟡 Calling miniCart.renderContents()');

//       miniCart.renderContents({
//         id: variantId,
//         sections: sections
//       });

//       console.log('🟢 renderContents() executed');

//     })
//     .catch(error => {
//       console.error('❌ Error occurred:', error);
//     })
//     .finally(() => {
//       btn.disabled = false;
//       console.log('🔵 Process finished');
//     });
//   });
// });


// document.addEventListener('DOMContentLoaded', function () {

//   document.querySelectorAll('.product-card-container').forEach((card, index) => {

//     const select = card.querySelector('.variant-selector');
//     const button = card.querySelector('.add-to-bag-btn');

//     if (!select || !button) return;

//     function updateButtonState() {
//       const selectedOption = select.options[select.selectedIndex];

//       if (selectedOption.disabled) {
//         button.classList.add('is-out-of-stock');
//         button.disabled = true;
//         button.innerText = 'Out of Stock';
//       } else {
//         button.classList.remove('is-out-of-stock');
//         button.disabled = false;
//         button.innerHTML = `
//           <span class="bag-icon">
//             <img src="https://cdn.shopify.com/s/files/1/0751/2142/6743/files/Bag_Icon_b843214a-bae6-4165-8d2b-75eda164c81e.svg"
//               alt="Bag Icon" class="img_bag_icn">
//           </span>
//           Add to Bag
//         `;
//       }
//     }

//     // Run on load
//     updateButtonState();

//     // Run on variant change
//     select.addEventListener('change', updateButtonState);
//   });

// });


// ✅ Arrow Scroll + Disable When At Ends
const productGrid = document.querySelector('.product-grid');
const leftArrow = document.querySelector('.left-arrow');
const rightArrow = document.querySelector('.right-arrow');
const scrollAmount = 300;

function updateArrows() {
    if (!productGrid) return;

    const scrollLeft = productGrid.scrollLeft;
    const maxScrollLeft = productGrid.scrollWidth - productGrid.clientWidth;

    if (leftArrow) {
        leftArrow.disabled = scrollLeft <= 0;
    }

    if (rightArrow) {
        rightArrow.disabled = scrollLeft >= maxScrollLeft - 5; // -5 for rounding tolerance
    }
}

if (leftArrow && rightArrow && productGrid) {
    updateArrows();

    leftArrow.addEventListener('click', () => {
        productGrid.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    });

    rightArrow.addEventListener('click', () => {
        productGrid.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });

    productGrid.addEventListener('scroll', updateArrows);

    // Optional: Re-check when window resizes
    window.addEventListener('resize', updateArrows);
}

// ✅ Variant Price Update
function initVariantPrice() {
  document.querySelectorAll('.product-card-container').forEach((card) => {

    const select = card.querySelector('.variant-selector');
    const priceContainer = card.querySelector('.product-price');
    const productJsonEl = card.querySelector('.product-json');

    if (!select || !priceContainer || !productJsonEl) return;

    const productData = JSON.parse(productJsonEl.textContent);

    select.addEventListener('change', function () {
      const variantId = this.value;

      const variant = productData.variants.find(v => v.id == variantId);
      if (!variant) return;

      let html = '';

      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        html += `<span class="original-price">${formatMoney(variant.compare_at_price)}</span>`;
      }

      html += `<span class="discounted-price">${formatMoney(variant.price)}</span>`;

      priceContainer.innerHTML = html;
    });

  });
}

// ✅ Money formatter
function formatMoney(cents) {
  return '₹' + (cents / 100).toFixed(2);
}

// Init
document.addEventListener('DOMContentLoaded', initVariantPrice);
document.addEventListener('shopify:section:load', initVariantPrice);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Taste_the_Purity_Section"] && !Shopify.designMode) return;
  try {
    
const productGrid = document.querySelector('.taste-the-purity-product-grid');
const leftArrow = document.querySelector('.taste-left-arrow');
const rightArrow = document.querySelector('.taste-right-arrow');

// Scroll amount per click
const scrollAmount = 300;

// Function to update arrow visibility
function updateArrows() {
  const scrollLeft = Math.ceil(productGrid.scrollLeft); // Use Math.ceil to avoid fractional issues
  const maxScrollLeft = Math.floor(productGrid.scrollWidth - productGrid.clientWidth); // Use Math.floor for consistency

  // Disable left arrow if at the beginning
  leftArrow.disabled = scrollLeft <= 0;

  // Disable right arrow if at the end (include a small threshold)
  rightArrow.disabled = scrollLeft >= maxScrollLeft - 2; // Subtract 2 for floating-point tolerance
}

// Function for scrolling left
leftArrow.addEventListener('click', () => {
  productGrid.scrollBy({
    left: -scrollAmount,
    behavior: 'smooth',
  });
  setTimeout(updateArrows, 300); // Add a slight delay to ensure the arrows update after scroll animation
});

// Function for scrolling right
rightArrow.addEventListener('click', () => {
  productGrid.scrollBy({
    left: scrollAmount,
    behavior: 'smooth',
  });
  setTimeout(updateArrows, 300); // Add a slight delay to ensure the arrows update after scroll animation
});

// Initially disable left arrow
updateArrows();

// Update arrow state after any scroll
productGrid.addEventListener('scroll', updateArrows);

// Update the cart count on page load (for refresh or initial load)
window.addEventListener('DOMContentLoaded', () => {
  updateCartCount();
});

// Function to update the cart count in the header
function updateCartCount() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const cartCount = document.querySelector('.cart-count');
      if (cartCount) {
        cartCount.textContent = cart.item_count; // Update the cart item count
      }
    })
    .catch(error => {
      console.error('Error fetching cart data:', error);
    });
}

// Add event listener to the "Add to Bag" buttons
// document.addEventListener('DOMContentLoaded', () => {
//   const addToBagButtons = document.querySelectorAll('.taste-the-purity-add-to-bag-btn');

//   addToBagButtons.forEach((button) => {
//     button.addEventListener('click', (e) => {
//       const parentContainer = e.target.closest('.taste-the-purity-taste-the-purity-product-card-container');
      
//       // Get the first variant ID of the product
//       const variantId = button.getAttribute('data-id');

//       if (variantId) {
//         // Redirect to cart with the first variant ID
//         const quantity = 1; // Default quantity
//         const cartUrl = `/cart/add?id=${variantId}&quantity=${quantity}`;
        
//         // Redirect to cart page
//         window.location.href = cartUrl;
//       } else {
//         alert('Unable to add the product to the cart. Please try again.');
//       }
//     });
//   });
// });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["WISHLIST_HERO_BKP_header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.connectedCallback();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 100);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);

      if (this.classList.contains('on-header')) {
        document.body.classList.remove('localization--open');
      }
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      this.hidePanel();
      // this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      // this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());

      if (this.classList.contains('on-header')) {
        document.body.classList.toggle('localization--open');
      }
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }
  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.connectedCallback();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 100);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
